<template>
    <div class="page-root">
        <div class="nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ name: 'INDEX' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{type | breadCN}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <c-tabs
                :width="691"
                :tabs="tabs"
                :tags="tags"
                :need-fixed="true"
                :first-tab="type === 'popular' || type === 'sales'
                    ? '全部' : ''"
                tab-label="name"
                tag-label="name"
                :default-tab-idx="defaultTabIdx"
                @change="handleTabsChange"
            />
            <div class="ranks-content">
                <div v-if="loading" class="page-loading">
                    <i class="el-icon-loading" />
                </div>
                <div v-if="dataList && dataList.length" class="ranks">
                    <router-link
                        v-for="(car, idx) in dataList"
                        class="ranks-item"
                        :to="{
                            name: 'CAR_TRAIN',
                            query: {
                                seriesName: car.series_name
                            },
                            params: {
                                serid: car.series_id
                            }
                        }"
                        target="_blank"
                        :key="car.series_id"
                        @click.native="logClickRankItem(car, idx)"
                    >
                        <template v-if="type !== 'newCar' && idx < 3">
                            <img
                                v-if="idx === 0" src="@/common/images/rank/1st.svg"
                                class="ranks-idx-img"
                            >
                            <img
                                v-else-if="idx === 1" src="@/common/images/rank/2nd.svg"
                                class="ranks-idx-img"
                            >
                            <img
                                v-else-if="idx === 2" src="@/common/images/rank/3rd.svg"
                                class="ranks-idx-img"
                            >
                        </template>
                        <p
                            v-if="type !== 'newCar' && idx >= 3"
                            class="ranks-idx"
                        >{{idx + 1}}</p>
                        <img src="@/assets/images/bitmap-small.png" v-real-src="car.white_bg_img">
                        <div class="info">
                            <div class="info-content">
                                <div class="info-name-series">
                                    <span class="info-name">{{car.series_name}}</span>
                                    <span v-if="car.tag" class="info-tag">{{car.tag}}</span>
                                </div>
                                <div class="info-price">{{car.price}}</div>
                            </div>
                            <div v-if="type === 'newCar'" class="car-publish">{{car.publish_time | parseDate}}上市</div>
                            <div v-else-if="
                                (type === 'popular'
                                || type === 'sales')
                                    && car.text"
                                class="car-pop
                            ">
                                <p>{{car.text.sub_title}}</p>
                                <p>{{car.text.title}}</p>
                            </div>
                        </div>
                    </router-link>
                </div>
                <div v-else-if="!loading" class="no-cars">
                    <img class="no-cars-logo" src="https://youjia.cdn.bcebos.com/bg/empty.png"></img>
                    <p>没有符合要求的车，换个筛选条件试试</p>
                </div>
            </div>
        </div>
        <c-scroll-top ref="scrollTop"/>
    </div>
</template>

<script>
/**
 * @file 排行榜
 * @author guozhihao02
 * @description 包含新车上市、人气排行榜、销量排行榜
 */
import request from 'http/request';
import URLS from 'http/URLS';
import {get} from 'lodash';
import {scrollTop} from 'js/Utils';
import {sendLog} from 'js/log';
import mixinLog from '@/mixin/log.js';
import scrollTopComponent from 'components/scroll-top';
import Tabs from '@/components/tabs';

const TYPE = ['newCar', 'popular', 'sales'];
export default {
    mixins: [mixinLog],
    components: {
        'c-tabs': Tabs,
        'c-scroll-top': scrollTopComponent
    },
    filters: {
        breadCN(eng) {
            switch (eng) {
                case 'newCar': return '新车上市';
                case 'popular': return '人气排行榜';
                case 'sales': return '销量排行榜';
                default: return '排行榜';
            }
        },
        parseDate(time) {
            if (time === null || time === 'undefined' || time === '') {
                return '';
            }
            // Safari不支持 yyyy-MM-dd HH:mm:ss 格式
            const date = new Date(time.replace(/-/g, '/'));
            if (date instanceof Date) {
                return date.getMonth() + 1 + '月' + date.getDate() + '日';
            }
            return '';
        }
    },
    data() {
        return {
            type: '',
            loading: false,
            tabs: [],
            tags: [],
            mainTabs: {},
            dataList: [],
            defaultTabIdx: 0
        };
    },
    created() {
        const {type} = this.$route.params;

        // 如果不是这三种，重定位到首页
        if (!type || !TYPE.includes(type)) {
            this.$router.push({name: 'INDEX'});
            return;
        }

        this.type = type;
        if (type === 'newCar') {
            this.getNewCar();
            this.defaultTabIdx = 1;
        }
        // 人气
        else if (type === 'popular') {
            this.getRankList('heat');
            this.defaultTabIdx = -1;
        }
        // 销量
        else if (type === 'sales') {
            this.getRankList('sale');
            this.defaultTabIdx = -1;
        }
    },
    methods: {
        getNewCar(month) {
            this.loading = true;
            request(URLS.getNewCarRankList, {
                month
            })
                .then(res => {
                    this.loading = false;
                    const {list = [], time = []} = get(res, 'Result', {});
                    if (!(this.tabs && this.tabs.length)) {
                        this.tabs = time;
                    }
                    this.dataList = list;
                })
                .catch(err => {
                    this.loading = false;
                    this.dataList = [];
                });
        },
        getRankList(sort, subLevel, newEnergy) {
            /* eslint-disable fecs-camelcase */
            this.loading = true;
            request(URLS.getRankList, {
                sort,
                sub_level: subLevel || '',
                new_energy: newEnergy || ''
            })
                .then(res => {
                    const {rank_level = [], list = []} = get(res, 'Result', {});
                    if (!(this.tabs && this.tabs.length)) {
                        this.tabs = rank_level;
                    }
                    this.dataList = list;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                    this.dataList = [];
                });
            /* eslint-enable fecs-camelcase */
        },
        handleTabsChange(e) {
            const {type, value, index} = e;
            if (type === 'main') {
                this.mainTabs = value;
                if (this.type === 'newCar') {
                    this.getNewCar(value.condition.month);
                }
                if (this.type === 'popular' || this.type === 'sales') {
                    this.getRankList(
                        this.type === 'popular' ? 'heat' : 'sale',
                        value.all ? '' : (value.condition && value.condition.sub_level) || '',
                        value.all ? '' : (value.condition && value.condition.new_energy) || ''
                    );
                    this.tags = value.value;
                }
                this.sendLog('change_tab', {
                    pos: index,
                    tabName: value.name
                });
            }
            else if (type === 'sub') {
                if (this.type === 'popular' || this.type === 'sales') {
                    this.getRankList(
                        this.type === 'popular' ? 'heat' : 'sale',
                        (value.condition && value.condition.sub_level) || '',
                        (value.condition && value.condition.new_energy) || ''
                    );
                }
                this.sendLog('change_tag', {
                    pos: index,
                    tabName: this.mainTabs.name,
                    tagName: value.name
                });
            }
            this.scrollTop();
        },
        logClickRankItem(car, idx) {
            this.sendLog('item_click', {
                seriesName: car.series_name,
                seriesId: car.series_id,
                pos: idx
            });
        },
        scrollTop() {
            const {offsetTop = 0} = document.querySelector('.page-root .container') || {};
            let scrollY = window.pageYOffset
                    || document.documentElement.scrollTop
                    || document.body.scrollTop;
            // 如果tab已经固定了，那么不需要返回顶部
            if (scrollY > offsetTop) {
                scrollTop(window, scrollY, offsetTop);
            }
        },
        sendLog(key, params) {
            sendLog(`ranks_${key}`, {
                page: this.type,
                ...(params || {})
            });
        }
    }
};
</script>

<style lang="less" scoped>
@themeColor: #00CECF;

.page-root {
    width: 691px;
    margin: 30px auto 0;
    padding-bottom: 80px;
}
.nav {
    margin-bottom: 36px;
    .el-breadcrumb {
        font-size: 16px;
    }
    /deep/ .el-breadcrumb__item {
        cursor: pointer;
        .el-breadcrumb__inner {
            color: #333;
            &.is-link {
                font-weight: 400;
            }
            &:hover {
                color: #333;
            }
        }
        &[aria-current="page"] .el-breadcrumb__inner {
            color: #333;
            cursor: default!important;
            &:hover {
                color: #333;
            }
        }
    }
}
.container {
    .ranks-content {
        position: relative;
        margin-top: 10px;
    }
    .ranks-item {
        display: flex;
        height: 110px;
        align-items: center;
        padding-top: 5px;
        cursor: pointer;
        .ranks-idx {
            width: 19px;
            height: 21px;
            margin-right: 14px;
            text-align: center;
            line-height: 23px;
            font-size: 14px;
            color: #333333;
            text-align: center;
            &-img {
                width: 19px;
                height: 21px;
            }
        }
        img {
            display: block;
            width: 150px;
            height: 100px;
            margin-right: 14px;
        }
        .info {
            flex: 1;
            display: flex;
            height: 100%;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 5px;
            border-bottom: 1px solid #EEEEEE;
            color: #333333;
            &-content {
                flex: 1;
            }
            &-name-series {
                display: flex;
                align-items: center;
                span {
                    display: inline-block;
                }
                .info-name {
                    font-size: 16px;
                    line-height: 16px;
                }
                .info-tag {
                    margin-left: 6px;
                    padding: 0 7px;
                    font-size: 12px;
                    line-height: 16px;
                    border-radius: 2px;
                    color: #333333;
                    background: #EEEEEE;
                }
            }
            &-price {
                margin-top: 8px;
                font-size: 14px;
                line-height: 14px;
                color: #FE4455;
            }
            .car-publish {
                font-size: 14px;
                color: #333333;
            }
            .car-pop {
                font-size: 14px;
                text-align: right;
                p {
                    &:first-child {
                        color: #666666;
                    }
                }
            }
        }
    }
    .page-loading {
        position: absolute;
        margin-top: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
        background: rgba(255, 255, 255, .60);
        i {
            display: block;
            font-size: 18px;
            width: 18px;
            margin: 30vh auto 0;
        }
    }
    /deep/ .tabs {
        .tabs-tag {
            border-radius: 4px;
            background: #F5F5F5;
            color: #666666;
            border: 1px solid #F5F5F5;
            &.tabs-active {
                border: 1px solid @themeColor;
                color: @themeColor;
                background: #FFFFFF;
            }
        }
    }
    .no-cars {
        margin: 100px auto 0;
        width: 300px;
        height: 100px;
        text-align: center;
        &-logo {
            width: 200px;
        }
        p {
            font-size: 16px;
        }
    }
}
</style>